// extracted by mini-css-extract-plugin
export default {"title":"styles_title__XdNCE","subTitle":"styles_subTitle__xwNnY"};